// CDN image utility with Cloudflare on-the-fly resizing
export const getCdnImage = (url, width = 800, quality = 80) => {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('assets.auxodev.dk')) return url;
  if (url.includes('/cdn-cgi/image/')) return url;
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`);
};

export const COMPANY_INFO = {
  name: 'AGT Nordic Group ApS',
  address: '4760 Vordingborg',
  zipCity: '4760 Vordingborg',
  phone: '70 60 89 40',
  phoneRaw: 'tel:+4570608940',
  email: 'sale@agtnordic.com',
  emailRaw: 'mailto:sale@agtnordic.com',
  soleDistributorText: 'Eneforhandler af SYSTEM 3E i Danmark',
};

export const SITE_IMAGES = {
  hero: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-29-panowie-na-niebie-tiny.jpg',
  elementsCloseUp: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-39-661ec3-0e3c0370213948c881248e78ad7220eb-mv2.jpg',
  clickClickDemo: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-38-661ec3-ddeeeb9d56964576bc5dec89336c2cf5-mv2.jpg',
  constructionSite: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-32-661ec3-83baaca20dac4f34ba99ddc6272eb337-mv2.jpg',
  calculatorHeader: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-2-calculator-header.jpg',
  projectVillaVordingborg: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/project-villa-vordingborg.png',
  start01: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/start-01.png',
  modularL01: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-4-modular-l-01.jpg',
  wallSystemElement: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-4-modular-l-01.jpg',
  wallSystemElementEdited: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-1-s1-wp-2-edited.png',
  shortVideo: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/pagevideo03.mp4',
  villaVordingborg: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-29-panowie-na-niebie-tiny.jpg',
  modernHouse: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/hero-modern-house.png',
  rowHouses: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-38-661ec3-ddeeeb9d56964576bc5dec89336c2cf5-mv2.jpg',
  commercialBuilding: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-39-661ec3-0e3c0370213948c881248e78ad7220eb-mv2.jpg',
  perliteDetail: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/imgi-1-s1-wp-2-edited.png',
};

export const NAV_LINKS = [
  { label: 'Forside', path: '/' },
  { label: 'SYSTEM 3E', path: '/system-3e' },
  { label: 'Sådan bygger du', path: '/sadan-bygger-du' },
  { label: 'Fordele', path: '/fordele' },
  { label: 'For private', path: '/for-private' },
  { label: 'For professionelle', path: '/for-professionelle' },
  { label: 'Projekter', path: '/projekter' },
  { label: 'Kontakt', path: '/kontakt' },
];

export const USPS = [
  {
    icon: 'fa-light fa-cube',
    title: 'Click-Click Montage',
    desc: 'Præcise geometriske elementer samles mekanisk. Ren Click-Click-teknologi uden traditionel mørtel, lim eller vand.',
  },
  {
    icon: 'fa-light fa-bolt',
    title: 'Hurtig Vægopbygning',
    desc: 'Oplev op mod 3-4 gange hurtigere vægkonstruktion end traditionelt murværk. Ydervæggene på et ~100 m² hus kan opføres på ét døgn under rette forhold.',
  },
  {
    icon: 'fa-light fa-leaf',
    title: 'Perlitbaseret System',
    desc: 'Naturligt og stærkt perlitmateriale, som giver både bærende styrke og fremragende termisk isolering i ét samlet element.',
  },
  {
    icon: 'fa-light fa-shield-halved',
    title: 'REI 240 + M Brandklasse',
    desc: 'Højeste sikkerhed med brandmodstand på op til 240 minutter samt mekanisk modstand dybt integreret i materialets kerne.',
  },
  {
    icon: 'fa-light fa-certificate',
    title: 'Eneforhandler i DK',
    desc: 'AGT Nordic Group ApS er den officielle og eksklusive danske eneforhandler af SYSTEM 3E.',
  },
];

export const CLICK_STEPS = [
  {
    step: '01',
    title: 'Placér',
    subtitle: 'Præcis placering',
    desc: 'Første skift oprettes vater fast på fundamentet. Elementerne placeres ubesværet manuelt uden tunge løfteredskaber.',
    image: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/start-01.png',
    alt: 'Placér',
  },
  {
    step: '02',
    title: 'Klik sammen',
    subtitle: 'Mekanisk samling',
    desc: 'Elementerne klikker perfekt sammen ved hjælp af den unikke udskårne geometri. Ingen mørtel, lim eller tørretid nødvendig.',
    image: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/middle-02.png',
    alt: 'Klik sammen',
  },
  {
    step: '03',
    title: 'Byg videre',
    subtitle: 'Uafbrudt proces',
    desc: 'Da der ikke benyttes våde materialer, kan væggen opbygges i ét uafbrudt forløb direkte op til fuld højde.',
    image: 'https://assets.auxodev.dk/assets/6db9bc06-2d1f-414d-89eb-eaf682030584/end-03.png',
    alt: 'Byg videre',
  },
];

export const TECHNICAL_SPECS = [
  { label: 'U-værdi (Basiselement)', value: '0,198 W/m²K', note: 'Producentdokumenteret isoleringsevne' },
  { label: 'Brandmodstand', value: 'REI 240 + M', note: 'Maksimal brandsikkerhed og stabilitet' },
  { label: 'Hovedmateriale', value: 'Perlite (Vulkansk sten)', note: 'Naturligt, mineral-baseret & uforgængeligt' },
  { label: 'Samlingsmetode', value: 'Click-Click mekanisk samling', note: '100% tør samling (ingen mørtel/lim/vand)' },
  { label: 'Elementtyper', value: '6 primære grundtyper', note: 'Komplet modulært byggesystem til alle vægvinkler' },
  { label: 'Byggehastighed', value: 'Op til 100 m² / døgn', note: 'Ydervægge under optimale byggepladsforhold' },
  { label: 'Miljø & Affald', value: 'Præcist beregnet levering', note: 'Minimalt tilskæringsspild på byggepladsen' },
  { label: 'Dansk Distributør', value: 'AGT Nordic Group ApS', note: 'Eneforhandler med rådgivning & projektsupport' },
];

export const REVIEWS = [
  {
    quote: 'Med SYSTEM 3E opførte vi råhuset på under halvdelen af den normale tid. Det tørre Click-Click system eliminerede fugtproblemer helt fra start.',
    author: 'Henrik Mortensen',
    role: 'Entreprenør & Bygmester',
    location: 'Sjælland',
  },
  {
    quote: 'Som privatbygherre gav det en enorm tryghed at opleve, hvor systematisk og præcist husets vægge skød i vejret. Både indeklima og isolering er i absolut topklasse.',
    author: 'Charlotte & Thomas',
    role: 'Husejere i nyt råhus',
    location: 'Vordingborg',
  },
  {
    quote: 'Click-Click princippet er en revolution for arbejdsgangen på pladsen. Vores håndværkere løfter mindre, arbejder hurtigere og undgår svineri med mørtel.',
    author: 'Lars Peter Jensen',
    role: 'Tømrermester',
    location: 'Næstved',
  },
  {
    quote: 'Præcisionen i perlitelementerne er bemærkelsesværdig. Ingen revnedannelser, fantastisk brandklasse og en markant forenkling af projekteringen.',
    author: 'Morten Lindberg',
    role: 'Bygningskonstruktør',
    location: 'København',
  },
];
